import ProductInfo from './ProductInfo.vue';

export default ProductInfo;
